export const UPDATE_ROLE = 'UPDATE_ROLE';
export const GET_SELECTED_ROLE = 'UPDATE_ROLE';
export const CREATE_ROLE = 'CREATE_ROLE';
export const GET_ACTION = 'GET_ACTION';
